import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';

interface Props {
  displayTitleOnly?: boolean;
  title?: string;
  value?: string;
}

export default function AccountItem({
  title,
  value,
  displayTitleOnly = false,
}: Props) {
  return (title && value) || displayTitleOnly ? (
    <div
      style={{
        color: Colors['light'],
        fontSize: `${28 * Screen.widthRatio}px`,
        display: 'flex',
        lineHeight: `${60 * Screen.widthRatio}px`,
      }}
    >
      <div
        style={{
          fontFamily: Fonts['bold'],
          marginRight: `${12 * Screen.widthRatio}px`,
        }}
      >
        {title}
      </div>
      <div style={{ fontFamily: Fonts['regular'] }}>{value}</div>
    </div>
  ) : null;
}
